import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectExternalLinks({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.links : [];
    },
    isRetrieveProjectExternalLinksRequestFailure({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isFailure : false;
    },
    isRetrieveProjectExternalLinksRequestPending({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isPending : false;
    },
    isRetrieveProjectExternalLinksRequestSuccess({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isSuccessful : false;
    },
  };
}

export { createSelector };
